import * as React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useStyles } from "../../layout/Styles";
import {
  Badge,
  Box,
  Card,
  Grid,
  Chip,
  CardContent,
  CardActions,
  Collapse,
  IconButton,
  ListItemIcon,
  Typography
} from "@mui/material";
import { red } from "@mui/material/colors";
import { MdNotifications, MdExpandMore } from "react-icons/md";
import { BsChatRightFill } from "react-icons/bs";
import { IoGiftSharp, IoPulseSharp } from "react-icons/io5";
import { RiMentalHealthFill } from "react-icons/ri";
import {
  FaClinicMedical,
  FaBriefcaseMedical,
  FaLaptopMedical,
  FaStethoscope,
  FaHandHoldingMedical,
  FaUserMd,
  FaVials,
  FaHeartbeat,
  FaCalendarPlus,
  FaFileMedicalAlt,
} from "react-icons/fa";

import CprCardHeader from "./CprCardHeader";
import LearnMore from "./LearnMore";
import Tooltip from "./Tooltip";
import Status from "./Status";
import nvenergyrewards from '../../../../../assets/images/nvenergyrewards.png'
import greenspunrewards from '../../../../../assets/images/greenspunrewards.png'
import { PatientData } from "../../Contexts";
import * as CONST from "../../Constants";

const CPR_MEDIA_MAPPING = [
  {
    code: "AWVS - Annual Wellness Visit (Scheduled)",
    bg: "#2cb5fa",
    icon: <FaLaptopMedical />,
    name: "Required PCP Visit",
  },
  {
    code: "AWV - Annual Wellness Visit",
    bg: "#2cb5fa",
    icon: <FaCalendarPlus />,
    name: "Required PCP Visit",
  },
  {
    code: "103 - Acute Care Visit",
    bg: "#42b3f4",
    icon: <IoPulseSharp />,
    name: "Acute Care Visit",
  },

  {
    code: "103 - Acute Care Visit (Scheduled)",
    bg: "#42b3f4",
    icon: <IoPulseSharp />,
    name: "Acute Care Visit",
  },
  {
    code: "001 - Newly Eligible - Establish Care",
    bg: "#ff63c9",
    icon: <FaUserMd />,
    name: "Required PCP Visit",
  },
  {
    code: "003 - PCP Change - Establish Care",
    bg: "#ff63c9",
    icon: <FaUserMd />,
    name: "Required PCP Visit",
  },
  {
    code: "102 - Required PCP Visit",
    bg: "#1a237e",
    icon: <FaStethoscope />,
    name: "Required PCP Visit",
  },
  {
    code: "102 - Required PCP Visit - Establish Care",
    bg: "#1a237e",
    icon: <FaHandHoldingMedical />,
    name: "Required PCP Visit",
  },
  {
    code: "001D - Newly Eligible - Establish Care (Due Date)",
    bg: "#1a237e",
    icon: <FaClinicMedical />,
    name: "Required PCP Visit",
  },
  {
    code: "203B - Required Specialist Visit",
    bg: "#780c75",
    icon: <RiMentalHealthFill />,
    name: " Required Specialist Visit",
  },
  {
    code: "203C - Required Lab Draw",
    bg: "#8b1d88",
    icon: <FaVials />,
    name: "Required Lab Draw",
  },
  {
    code: "203D - Required Preventive Service",
    bg: "#4c1d8b",
    icon: <FaBriefcaseMedical />,
    name: " Required Preventive Service",
  },
  {
    code: "203E - Required Imaging/Diagnostic",
    bg: "#1d8b8a",
    icon: <FaFileMedicalAlt />,
    name: "Required Imaging/Diagnostic",
  },
];

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const propTypes = {
  window: PropTypes.func,
  cpr: PropTypes.object.isRequired,
  expandPanel: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  prompt: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    handler: PropTypes.func.isRequired,
  }),
  children: PropTypes.object,
};
CprCard.prototype = propTypes;
export default function CprCard(props) {
  const location = useLocation();
  const [expanded, setExpanded] = React.useState(false);
  const [media, setMedia] = React.useState(null);
  const patient = React.useContext(PatientData);
  let styles = useStyles();

  React.useEffect(() => {
    if (!media) {
      let index = CPR_MEDIA_MAPPING.findIndex((item) =>
        item.code == props.cpr.cpr_code ? item : null
      );
      index <= -1
        ? setMedia({
            code: props.cpr.cpr_code,
            bg: "#ea80fc",
            icon: <FaHeartbeat />,
            name: props.cpr.cpr_code,
          })
        : setMedia({
            ...CPR_MEDIA_MAPPING[index],
          });
    }
  }, [props.cpr]);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const Reward = () => {
    return (
      <>
        {patient.health_plan == "NV Energy" ? (
          <Tooltip
            content={<img src={nvenergyrewards} className="reward" />}
            tooltip={
              <Chip
                aria-label="CPR reward tooltip"
                sx={{ bgcolor: "#1bbca3" }}
                icon={<IoGiftSharp className="primary" />}
                label={CONST.REWARDS}
              />
            }
          />
        ) : patient.health_plan == "Greenspun Media Group" ? (
          <Tooltip
            content={<img src={greenspunrewards} className="reward" />}
            tooltip={
              <Chip
                aria-label="CPR reward tooltip"
                sx={{ bgcolor: "#1bbca3" }}
                icon={<IoGiftSharp className="primary" />}
                label={CONST.REWARDS}
              />
            }
          />
        ) : (props.cpr.reward_data && props.cpr.reward_data.reward_amount) ? (
          <Tooltip
            label={"$" + props.cpr.reward_data.reward_amount + " " + CONST.REWARD}
            tooltip={
              <Chip
                aria-label="CPR reward tooltip"
                sx={{ bgcolor: "#1bbca3" }}
                icon={<IoGiftSharp className="primary" />}
                label={"$" + props.cpr.reward_data.reward_amount + " " + CONST.REWARD}
              />
            }
            content={
              <>
                <Box fontSize="23px" color={"#1bbca3"} lineHeight="1.7" fontWeight="600">
                  <IoGiftSharp style={{ fontSize: "27px", margin: "4px 4px -4px 0" }} />
                  {"$" + props.cpr.reward_data.reward_amount + " " + CONST.REWARD_OPPORTUNITY}
                </Box>
                <div class='m-t-lg'>
                  <Typography variant="body1">{props.cpr.reward_data.reward_message_1}</Typography>
                </div>
              </>
            }
          />
        ) : null}
      </>
    );
  };

  return (
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={12}>
        <Card className="patient-feed-card">
          {media && (
            <CprCardHeader
              cpr={props.cpr}
              promptHandler={props.prompt.handler}
              hideActions={false}
              hideAvatar={false}
              reward={<Reward />}
              spacing={true}
              media={media}
              variants={{
                icon: props.cpr.needs_attention && <MdNotifications />,
                bg: props.cpr.needs_attention ? red[500] : "#f6f6f6",
              }}
            />
          )}
          {props.cpr.cpr_label && (
            <>
              <CardActions disableSpacing>
                <IconButton
                  className="card-button panel"
                  onClick={handleExpandClick}
                  aria-label="show why this is required"
                >
                  {expanded ? CONST.HIDE : CONST.WHY_THIS_IS_REQUIRED}
                </IconButton>
                <ExpandMore
                  className="card-button"
                  expand={expanded}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show learn more about this cpr"
                >
                  <MdExpandMore />
                </ExpandMore>
              </CardActions>
              <CardContent classNames={'cpr-card-content'}>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <LearnMore
                    procedureType={props.cpr.procedure_type}
                    name={media && media.name}
                    description={
                      props.cpr.cpr_label.cpr_description
                        ? props.cpr.cpr_label.cpr_description
                        : null
                    }
                    eligibility={
                      props.cpr.cpr_label.eligibility_text
                        ? props.cpr.cpr_label.eligibility_text
                        : null
                    }
                    frequency={
                      props.cpr.cpr_label.frequency_text ? props.cpr.cpr_label.frequency_text : null
                    }
                    hasReward={
                      props.cpr.reward_data && props.cpr.reward_data.reward_amount ? true : false
                    }
                  />
                </Collapse>
              </CardContent>
            </>
          )}

          <Status
            status={props.cpr.status}
            acknowledgedAfterOutcome={props.cpr.acknowledgedAfterOutcome}
            dispatch={props.dispatch}
            outcomeMessage={props.cpr.outcome_message}
            rejectedComment={
              props.cpr.rejected_comment && props.cpr.rejected_comment.length >= 1 ? props.cpr.rejected_comment[0] : null
            }
            responseSubmitted={props.cpr.response_submitted}
            questionSubmitted={props.cpr.question_submitted}
            responseStatus={props.cpr.cpr_type_response_status}
            appointment_date={props.cpr.appointment_date}
            inReview={props.cpr.in_review}
            order_not_available_reason={props.cpr.order_not_available_reason}
            orderRequested={props.cpr.patient_requested_order}
            dateUpdated={
              props.cpr.updatedDueDate || props.cpr.updatedAppointmentDate ? true : false
            }
            order={props.cpr.order_document && props.cpr.order_document.url}
            needsResponse={props.cpr.needs_attention}
            id={props.cpr.id}
            response={props.cpr.current_response}
            toggleMessages={
              !!props.cpr.task_messages.length > 0 &&
              location.pathname.includes("dashboard") && (
                <IconButton
                  className="card-button"
                  aria-label="view messages"
                  sx={{ marginLeft: "auto" }}
                  onClick={(e) => {
                    e.preventDefault();
                    props.prompt.handler("message");
                  }}
                >
                  <BsChatRightFill className={styles.chatIcon} />
                  <ListItemIcon sx={{ minWidth: "0px !important"}}>
                    <Badge sx={{ minWidth: "0px !important"}} badgeContent={props.cpr.task_messages.length} color="error">
                    </Badge>
                  </ListItemIcon>
                  <i className='fa fa-hand-pointer-o'></i>
                </IconButton>
              )
            }
          />

          <CardContent className={'cpr-card-content'}>
            {props.expandPanel}
            {props.children}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
